import React from 'react'
import { Typography } from '@material-ui/core'
import CMSText, { prismicText } from '../Global/CMSText'
import { useAccountStyles } from './AccountStyles'
import { useTranslation } from 'react-i18next'
import clsx from 'clsx'

export const AccountFaq = ({ doc }) => {
  const classes = useAccountStyles()
  const { t } = useTranslation()
  return (
    <div className={classes.questionContainer}>
      <Typography
        variant={'h4'}
        color={'primary'}
        align={'center'}
        className={`${classes.smallMarginBottom} account__questions`}
      >
        {prismicText(doc?.data?.block_title, t('texts:account:block_title'))}
      </Typography>
      {doc?.data
        ? doc?.data?.block.map((item, index) => (
            <div key={index}>
              <Typography variant={'body2'} className="account__question">
                <b>{prismicText(item?.bold_sentence)}</b>
              </Typography>
              <Typography
                variant={'body2'}
                className={clsx('account__answer', classes.smallMarginBottom)}
                component={'div'}
              >
                <CMSText data={item?.paragraph} />
              </Typography>
            </div>
          ))
        : [0, 1].map((index) => (
            <div key={index}>
              <Typography variant={'body2'} className="account__question">
                <b>{t('texts:general:add_a_title')}</b>
              </Typography>
              <Typography
                variant={'body2'}
                className={clsx('account__answer', classes.smallMarginBottom)}
              >
                {t('texts:general:add_a_description')}
              </Typography>
            </div>
          ))}
    </div>
  )
}
